import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ReflectionModal from '../components/reflection/ReflectionModal';

/**
 * Main Reflection Page - Shows modal with calendar view
 * Route: /reflection
 */
const ReflectionPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // Open modal when page loads
  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Navigate back after animation completes
    setTimeout(() => {
      navigate(-1);
    }, 300);
  };

  return (
    <div>
      <ReflectionModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default ReflectionPage;
